import { v4 as uuidv4 } from 'uuid';
export const getFormValues = (setting) => {
    if (!setting) {
        return {
            type: 'text',
            id: '',
        };
    }
    switch (setting.type) {
        case 'header':
            return {
                type: setting.type,
                id: uuidv4(), // Needed because there is no id in the setting but we need a unique id for drag / drop to work
                content: setting.content,
            };
        case 'text':
            return {
                type: setting.type,
                id: setting.id,
                label: setting.label,
                info: setting.info,
                default: setting.default,
                placeholder: setting.placeholder,
            };
        case 'number':
            return {
                type: setting.type,
                id: setting.id,
                label: setting.label,
                info: setting.info,
                default: setting.default,
                placeholder: setting.placeholder,
            };
        case 'color':
            return {
                type: setting.type,
                id: setting.id,
                label: setting.label,
                info: setting.info,
                default: setting.default,
            };
        case 'checkbox':
            return {
                type: setting.type,
                id: setting.id,
                label: setting.label,
                info: setting.info,
                default: setting.default,
            };
        case 'radio':
            return {
                type: setting.type,
                id: '',
                label: setting.label,
                info: setting.info,
                default: setting.default,
                options: setting.options,
            };
        case 'select':
            return {
                type: setting.type,
                id: setting.id,
                label: setting.label,
                info: setting.info,
                default: setting.default,
                options: setting.options,
            };
        case 'range':
            return {
                type: setting.type,
                id: setting.id,
                label: setting.label,
                default: setting.default,
                min: setting.min,
                max: setting.max,
                step: setting.step,
                unit: setting.unit,
            };
    }
};
